import { getDriverTripData } from "./getDriverTripData"
import { getFarmTripData } from "./getFarmTripData"

import type { TripCategory } from "../types/logisticsTypes"

export const getTripData = async (cat: "farms" | "drivers"): Promise<TripCategory[]> => {
  return cat == "farms" ? await getFarmTripData() : await getDriverTripData()
}
